import React, { ReactNode, ReactElement } from "react";
import {
  Flex,
  Text,
  Card,
  CardHeader,
  CardIcon,
  CardTitle,
  CardBody,
  Tooltip,
  Avatar,
  SimpleGrid,
  Heading,
} from "@govlaunch/web";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";
import { FormattedMessage } from "react-intl";

interface IStoryCollaboratorsProps {
  products: IStoryFieldsFragment["products"];
  renderLinkWrap?: (product: NonNullable<IStoryFieldsFragment["products"]>[0], children: ReactNode) => ReactElement;
}

export default function StoryProducts({ products, renderLinkWrap }: IStoryCollaboratorsProps) {
  return (
    <>
      <Heading as="h3" color="blue.500" fontWeight="bold" fontSize="18" mb={4}>
        <FormattedMessage defaultMessage="Products" id="7NFfmz" />
      </Heading>
      <div css={{ paddingLeft: 10 }}>
        <SimpleGrid columns={1} spacing={2}>
          {products?.map((product) => {
            const children = (
              <Flex align="center">
                <Avatar
                  src={product.logo}
                  name={product.name}
                  size="sm"
                  variant={product.isDisruptor ? "disruptor" : null}
                  mr={4}
                />
                <Tooltip key={product._id} label={product.name} bg="blue.600" color="white">
                  <Text isTruncated={true} fontSize="md">
                    {product.name}
                  </Text>
                </Tooltip>
              </Flex>
            );

            return renderLinkWrap ? renderLinkWrap(product, children) : children;
          })}
        </SimpleGrid>
      </div>
    </>
  );
}
